<template>
<header class="bg-white bg-opacity-0">
    <div class="mx-auto flex flex-wrap pt-2 md:pt-16 lg:pt-2 flex-col md:flex-row items-center justify-center w-full" :class="{'text-black': !isLandingPage, 'text-white': isLandingPage}">
        <router-link to="/">
            <div class="flex flex-col items-center">
                <img :class="{'w-20': isLandingPage, 'w-10': !isLandingPage}" :src="isLandingPage ? logo.white : logo.black" />
                <h5 v-if="isLandingPage" class="font-mono text-nano mt-4">Street is a state of mind</h5>
            </div>
        </router-link>
        <button v-if="showCart" tabindex="0" class="nav__cart" @click="goToCart">
            <div class="icon">
                <img :src="cartIcon" alt="Click to view cart" class="w-8 h-8">
                <span v-if="cart !== null">{{ cart.total_items }}</span>
                </div>
        </button>
    </div>
</header>
</template>

<script>
import whiteLogo from '../assets/logo_white.png';
import blackLogo from '../assets/logo_black.png';
const cartIcon = require('../assets/shopping-bag-1.png');
import {
    library
} from '@fortawesome/fontawesome-svg-core';
import {
    faShoppingBag,
    faTimes
} from '@fortawesome/free-solid-svg-icons';
library.add(faShoppingBag, faTimes);
export default {
    name: 'Header',
    props: {
        showCart: {
            default: false
        },
    },
    computed: {
        isLandingPage() {
            return this.$route.name === 'landing-page';
        },
        cart() {
            return this.$store.getters['app/cart'] || {};
        },
    },
    data() {
        return {
            logo: {
                white: whiteLogo,
                black: blackLogo
            },
            cartIcon: cartIcon,
        }
    },
    methods: {
        /**
         * Toggles the cart
         */
        goToCart() {
            this.$router.push('/shop/cart')
        },
    }
}
</script>

<style lang="scss" scoped>
.text-nano {
    font-size: 0.4rem;
    line-height: 0.75rem;
}

.nav {
    @apply fixed;
    top: 1rem;
    right: 1.25rem;
    z-index: 999;

    &__cart {
        @apply absolute right-4 sm:right-28 md:right-24 lg:right-36 xl:right-44;
        .icon {
            @apply flex flex-row hover:opacity-75;
        }
        span {
            @apply text-xs font-mono py-0 px-0 rounded-full align-top;
        }
    }
}
</style>
